import { Slide } from '@/components/core/Slide';
import { ImageCarousel } from '@/components/visualizers/ImageCarousel';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './23-sofie.mp3';

const transcript = `
  Ik kan hier eindeloos over doorgaan, zoals wij vaak samen doen. Maar ik monitor ondertussen de zaal en 
  stel voor dat we het technische gedeelte hierbij laten.

  Zou je niet nog vertellen over hoe jij met synthografie bent begonnen, met Sofie? 
  Ik vind dat een schitterend verhaal...

  Ik zie haar ook een beetje als familie.
`;

// Jonathan: Vertelt over Sofie .

const images = [
  'https://cdn.midjourney.com/3978568b-55d1-47c3-bcb7-ff7ba7530916/0_0.png',
  'https://cdn.midjourney.com/579af075-ce49-464a-a058-425353e6d1c4/0_3.png',
  'https://cdn.midjourney.com/6e3ef891-e419-49cd-b8fd-c0e12c6b0d5e/0_2.png',
  'https://cdn.midjourney.com/94e0f9a6-a328-4c32-92ea-ac0961ed4b4f/0_0.png',
  'https://cdn.midjourney.com/203d4a5d-a37a-4a1e-907e-8a69bba5e32d/0_0.png',
  'https://cdn.midjourney.com/949c972c-acfd-4184-aff3-cfded3ce9ae4/0_3.png',
  'https://cdn.midjourney.com/5dd58bf5-5926-4ba5-ba86-425b79195f94/0_0.png',
  'https://cdn.midjourney.com/f384f65d-3241-4fae-b773-4e40b98b2173/0_2.png',
  'https://cdn.midjourney.com/0163b971-aac7-49be-84e1-ee362f468691/0_0.png',
  'https://cdn.midjourney.com/3441f610-cca9-4648-a1c0-29ddeacbea04/0_3.png',
  'https://cdn.midjourney.com/6e9f199b-0a26-4a01-8381-fe69c25b8f7b/0_2.png',
  'https://cdn.midjourney.com/a1697ae9-f4c8-422f-b4a5-09843495efa7/0_0.png',
];

// Jonathan: Vertelt over Sofie .

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full" networkBackground="full">
      <div className="flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 5000,
            duration: 2000,
          }}
        >
          <ImageCarousel images={images} speed={0.002} />
        </WebContent>
      </div>
    </Slide>
  );
};
